export default __webpack_public_path__ + "media/zurb/img/events/wired/pie-ranch/pr-1-a9c47a2f835534df5345c84862c61789.jpg";